<template>
    <ol class="breadcrumb p-0">
        <li
            v-for="(breadcrumb, index) in breadcrumbList"
            :key="index + 0"
            class="breadcrumb-item text-uppercase"
            @click="routeTo(index)"
        >
            <router-link :to="{ name: breadcrumb.name }" v-if="breadcrumb.link">{{ $t(breadcrumb.title) }}</router-link>
            <span v-if="!breadcrumb.link">{{ $t(breadcrumb.title) }}</span>
        </li>
    </ol>
</template>

<script>
export default {
  data () {
    return {
      breadcrumbList: []
    }
  },
  mounted () {
    this.updateList()
  },
  watch: {
    '$route' () {
      this.updateList()
    }
  },
  methods: {
    routeTo (pRouteTo) {
      console.log('RouteTo:')
      console.log(pRouteTo)
      console.log('Route:')
      console.log(this.breadcrumbList[pRouteTo].link)
      console.log(this.breadcrumbList)
      if (this.breadcrumbList[pRouteTo].link) {
        this.$router.push(this.breadcrumbList[pRouteTo].link)
      }
    },
    updateList () {
      this.breadcrumbList = this.$route.meta.breadcrumb
    }
  }
}
</script>

<style>
    .breadcrumb span {
        font-size: 13px;
        font-family: "Open Sans Semibold";
    }
</style>



// WEBPACK FOOTER //
// src/components/core/Breadcrumb.vue